import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalePipe } from './pipes/locale.pipe';
import { HeaderComponent } from './components/header/header.component';
import { MatIconModule } from '@angular/material/icon';
import { LogoComponent } from './components/logo/logo.component';
import { NavContentComponent } from './components/nav-content/nav-content.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FamilyGroupListComponent } from './components/family-group-list/family-group-list.component';
import { SelectItemComponent } from './components/select-item/select-item.component';
import { MatListModule } from '@angular/material/list';
import { BackButtonDirective } from './directives/back-button/back-button.directive';
import { RoundPipe } from './pipes/round.pipe';
import { RouterModule } from '@angular/router';
import { StylePaginatorDirective } from './directives/paginator/style-paginator.directive';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { StepperComponent } from './components/stepper/stepper.component';
import { LocalizedNamePipe } from './pipes/localized-name.pipe';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { DatepickerCustomHeaderComponent } from './components/datepicker-custom-header/datepicker-custom-header.component';
import { DatepickerDialogComponent } from './components/datepicker-dialog/datepicker-dialog.component';
import { SlideToggleComponent } from './components/slide-toggle/slide-toggle.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { FileSizeDecimalPipe } from './pipes/file-size-decimal.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { DialogComponent } from './components/dialog/dialog.component';
import { DataValidationComponent } from './components/data-validation/data-validation.component';
import { MatSelectModule } from '@angular/material/select';
import { BackgroundImageComponent } from './components/background-image/background-image.component';
import { StickerComponent } from './components/sticker/sticker.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { TitleComponent } from './components/title/title.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ExtendedButtonDirective } from './directives/extended-button/extended-button.directive';
import { ScoreComponent } from '../../components/score/score.component';
import { TruncatePipe } from '../../pipes/truncate.pipe';
import { NgxMaterialIntlTelInputComponent } from 'ngx-material-intl-tel-input';
import { ErrorMessagePipe } from 'src/app/pipes/error-message.pipe';
import { ScrollHintDirective } from 'src/app/directives/scroll-hint.directive';
import { MatDividerModule } from '@angular/material/divider';
import { CallFilesListComponent } from './components/call-files-list/call-files-list.component';
import { CallFilesDialogComponent } from './components/call-files-dialog/call-files-dialog.component';
import { SelectComponent } from './components/select/select.component';

@NgModule({
  declarations: [
    LocalePipe,
    RoundPipe,
    LocalizedNamePipe,
    FileSizeDecimalPipe,
    FileSizePipe,
    SafeUrlPipe,
    HeaderComponent,
    LogoComponent,
    NavContentComponent,
    FamilyGroupListComponent,
    SelectItemComponent,
    BackButtonDirective,
    StylePaginatorDirective,
    AutocompleteComponent,
    StepperComponent,
    DatepickerComponent,
    DatepickerCustomHeaderComponent,
    DatepickerDialogComponent,
    SlideToggleComponent,
    DialogComponent,
    DataValidationComponent,
    BackgroundImageComponent,
    StickerComponent,
    TitleComponent,
    ExtendedButtonDirective,
    TruncatePipe,
    CallFilesListComponent,
    CallFilesDialogComponent,
    SelectComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatListModule,
    RouterModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatDividerModule,
    MatSelectModule,
    ScoreComponent,
    NgxMaterialIntlTelInputComponent,
    ErrorMessagePipe,
    ScrollHintDirective
  ],
  exports: [
    LocalePipe,
    RoundPipe,
    LocalizedNamePipe,
    FileSizeDecimalPipe,
    FileSizePipe,
    SafeUrlPipe,
    HeaderComponent,
    LogoComponent,
    NavContentComponent,
    FamilyGroupListComponent,
    SelectItemComponent,
    StylePaginatorDirective,
    AutocompleteComponent,
    StepperComponent,
    DatepickerComponent,
    DatepickerDialogComponent,
    SlideToggleComponent,
    DialogComponent,
    BackgroundImageComponent,
    StickerComponent,
    DataValidationComponent,
    BackButtonDirective,
    TitleComponent,
    ExtendedButtonDirective,
    TruncatePipe,
    CallFilesListComponent,
    CallFilesDialogComponent,
    SelectComponent
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, { provide: LOCALE_ID, useValue: 'en-GB' }, MatDatepickerModule]
})
export class SharedModule {}
